<template>
<div>
    <b-spinner v-if="loading" variant="primary" label="Spinning"></b-spinner>

    <b-table-simple v-else hover responsive>
        <b-thead>
            <b-th> {{$t('account.vacation.desc')}} </b-th>
            <b-th> {{$t('account.vacation.beginDate')}} </b-th>
            <b-th> {{$t('account.vacation.endDate')}} </b-th>
            <b-th> {{$t('account.vacation.yearIndependent')}} </b-th>
            <b-th> {{$t('account.list.actions')}} </b-th>
        </b-thead>
        <b-tbody>
           <b-tr v-for="vac in vacations" :key="vac.id">
                <b-td> {{vac.name}} </b-td>
                <b-td> {{moment(vac.begin_date)}} </b-td>
                <b-td> {{moment(vac.end_date)}} </b-td>
                <b-td> 
                     <b-icon v-if="vac.is_every_year" icon="check" variant="success" scale="1.25" shift-v="1.25" aria-hidden="true"></b-icon> 
                    <b-icon v-else icon="x" variant="danger" scale="1.25" shift-v="1.25" aria-hidden="true"></b-icon>
                </b-td>
                <b-td> 
                    <b-icon icon="pencil-square" variant="primary" scale="1.25" shift-v="1.25" aria-hidden="true"  @click="openModal('edit', vac)"  ></b-icon>
                    <b-icon icon="trash" variant="danger" scale="1.25" shift-v="1.25" aria-hidden="true" @click="openModal('delete', vac)"></b-icon>
                </b-td>

            </b-tr>
        </b-tbody>
    </b-table-simple>
    </div>
</template>

<script>
    import moment from 'moment'
    export default {
        name: "VacationForm",
        props: {
            modalEvent: { type: Function },
            modalType: { type: Function }
        },
        methods:{
            openModal:function(name, data){
                this.modalType(true, 'Vacation', 9)
                this.modalEvent(true, name, data)
            },
            moment: function(data){
                return moment(data).format('DD MMMM YYYY');
            },
        },
        computed: {
            accountId(){
                return this.$store.getters.accountId
            },
            vacations(){
                return this.$store.getters.getAccountVacations
            },
            loading(){
                return this.$store.getters.getAccountLoading
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/pages/Alarmsis/Account/components/Vacation.vue